import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const generatePayrollRun = async (data) => {
  const res = await axiosInstance.post("/api/payroll-portal/create", data);
  return res.data;
};

export const getAllPayrollRuns = async (filters = {}) => {
  const res = await axiosInstance.get("/api/payroll-portal/all", { params: filters });
  return res.data;
};

export const getPayrollRunById = async (id) => {
  const res = await axiosInstance.get(`/api/payroll-portal/${id}`);
  return res.data;
};

export const getPayslipsByRun = async (id) => {
  const res = await axiosInstance.get(`/api/payroll-portal/${id}/payslips`);
  return res.data;
};

export const approvePayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-portal/approve/${id}`);
  return res.data;
};

export const publishPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-portal/publish/${id}`);
  return res.data;
};

export const rejectPayrollRun = async (id, reason = "") => {
  const res = await axiosInstance.put(`/api/payroll-portal/reject/${id}`, {
    reason,
  });
  return res.data;
};

export const revertPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-portal/revert/${id}`);
  return res.data;
};

export const lockPayrollRun = async (id) => {
  const res = await axiosInstance.put(`/api/payroll-portal/lock/${id}`);
  return res.data;
};

export const updatePayslipPayment = async (id, data) => {
  const res = await axiosInstance.put(
    `/api/payroll-portal/payslips/payment/${id}`,
    data
  );
  return res.data;
};

export const bulkUpdatePayslipPayment = async (runId, data) => {
  const res = await axiosInstance.put(
    `/api/payroll-portal/payslips/payment/bulk/${runId}`,
    data
  );
  return res.data;
};

export const getMyPayslips = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/my");
  return res.data;
};

export const getMyPayslipById = async (id) => {
  const res = await axiosInstance.get(`/api/payroll-portal/my/${id}`);
  return res.data;
};
